import React, { useState } from "react";
import PropTypes from "prop-types";
import LocationFilter from "./LocationFilter";
import PriceFilter from "./PriceFilter";
import SizeFilter from "./SizeFilter";
import LeaseTermFilter from "./LeaseTermFilter";
import CoWorkingFilter from "./CoWorkingFilter";
import SaveActiveRequirementsButton from "./SaveActiveRequirementsButton";

const Filters = ({ className, locationFilterTargetedLocations }) => {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    if (openMenu !== menuName) {
      setOpenMenu(menuName);
    } else {
      setOpenMenu(null);
    }
  };
  return (
    <div className={className} data-qa="ice-filters">
      <LocationFilter
        targetedLocations={locationFilterTargetedLocations}
        onToggle={() => toggleMenu("neighborhoods")}
        open={openMenu === "neighborhoods"}
      />

      <SizeFilter
        onToggle={() => toggleMenu("size")}
        open={openMenu === "size"}
      />

      <PriceFilter
        open={openMenu === "price"}
        onToggle={() => toggleMenu("price")}
      />

      <LeaseTermFilter
        open={openMenu === "leaseTerm"}
        onToggle={() => toggleMenu("leaseTerm")}
      />
      <CoWorkingFilter />

      <SaveActiveRequirementsButton />
    </div>
  );
};

Filters.propTypes = {
  className: PropTypes.string,
  locationFilterTargetedLocations: PropTypes.arrayOf(
    PropTypes.shape({
      city: PropTypes.string.isRequired,
      neighborhoods: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};

Filters.defaultProps = {
  className: "",
  locationFilterTargetedLocations: [],
};

export default Filters;
